/**
 * Shared Robi chat constants (web).
 *
 * The assistant avatar is a bundled asset, so it stays with the UI layer and is
 * passed into `useRobiChat` rather than hardcoded here. Web bundles cannot use
 * Metro-style `require`, so the avatar is left undefined.
 */
export const ROBI_CHAT_USER: { _id: string; name: string; avatar?: unknown } = {
  _id: 'robi',
  name: 'Robi',
  avatar: undefined,
};

export const ROBI_CONVERSATION_ID = 'robi-assistant';

export const generateRobiMessageId = (): string =>
  `robi-msg-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
